import { FC } from 'react';

import { RuleServiceWrapper } from './components';
import { SCUIContent } from '../../atomic/organisms';

import { RuleServiceProvider } from './context/RuleServiceContext';

export const RuleServiceV2: FC<any> = () => {
    return (
        <SCUIContent>
            <RuleServiceProvider>
                <RuleServiceWrapper />
            </RuleServiceProvider>
        </SCUIContent>
    );
};
